/**
 * ui/storyboard-template.js
 * Tạo template HTML cho Thẻ Phân Cảnh (Shot Card) trong Storyboard.
 */

import { escapeHtml } from '../../core/html.js';

export function buildShotCardHtml(shot, idx, totalShots, allChars) {
  const isFirst = idx === 0;
  const isLast = idx === totalShots - 1;
  const canDelete = totalShots > 1;

  const dur = Number(shot.duration);
  const duration = Number.isFinite(dur) && dur > 0 ? dur : 3;

  const actorOptions = allChars
    .map(
      (c) =>
        `<option value="${escapeHtml(c.id)}" ${c.id === shot.actorId ? 'selected' : ''}>${escapeHtml(c.name)}</option>`
    )
    .join('');

  return `
    <div class="shot-card-header">
      <span class="shot-num-badge">Shot ${idx + 1}</span>
      <input type="text" class="shot-title-input" value="${escapeHtml(shot.title || `Phân cảnh ${idx + 1}`)}" placeholder="Tiêu đề..." />
      <div class="shot-duration-wrap">
        <input type="number" class="shot-duration-input" min="0.5" max="60" step="0.5" value="${duration}" />
        <span>giây</span>
      </div>
      <div class="shot-card-controls">
        <button class="shot-icon-btn btn-shot-up" title="Di chuyển lên" ${isFirst ? 'disabled' : ''}>⬆️</button>
        <button class="shot-icon-btn btn-shot-down" title="Di chuyển xuống" ${isLast ? 'disabled' : ''}>⬇️</button>
        <button class="shot-icon-btn btn-shot-clone" title="Nhân bản phân cảnh">📋</button>
        <button class="shot-icon-btn danger btn-shot-del" title="Xóa phân cảnh" ${!canDelete ? 'disabled' : ''}>🗑️</button>
      </div>
    </div>

    <div class="shot-row-2col">
      <div>
        <label class="shot-select-label">👤 Diễn viên chính:</label>
        <select class="shot-select sel-shot-actor">
          ${actorOptions}
        </select>
      </div>
      <div>
        <label class="shot-select-label">📍 Vị trí đứng:</label>
        <select class="shot-select sel-shot-spawn">
          <option value="sidewalk_center" ${shot.spawnPoint === 'sidewalk_center' ? 'selected' : ''}>Giữa vỉa hè</option>
          <option value="sidewalk_left" ${shot.spawnPoint === 'sidewalk_left' ? 'selected' : ''}>Lề trái vỉa hè</option>
          <option value="sidewalk_right" ${shot.spawnPoint === 'sidewalk_right' ? 'selected' : ''}>Lề phải vỉa hè</option>
          <option value="tea_stall_bench" ${shot.spawnPoint === 'tea_stall_bench' ? 'selected' : ''}>Bàn trà đá</option>
          <option value="tea_stall_owner" ${shot.spawnPoint === 'tea_stall_owner' ? 'selected' : ''}>Góc bán trà</option>
        </select>
      </div>
    </div>

    <div class="shot-row-2col">
      <div>
        <label class="shot-select-label">⚡ Cử động / Dáng:</label>
        <select class="shot-select sel-shot-action">
          <option value="idle" ${shot.action === 'idle' ? 'selected' : ''}>Nghỉ (Idle)</option>
          <option value="wave" ${shot.action === 'wave' ? 'selected' : ''}>Vẫy tay chào (Wave)</option>
          <option value="talking" ${shot.action === 'talking' ? 'selected' : ''}>Nói chuyện (Talking)</option>
          <option value="cheer" ${shot.action === 'cheer' ? 'selected' : ''}>Cổ vũ / Vui mừng (Cheer)</option>
          <option value="greet" ${shot.action === 'greet' ? 'selected' : ''}>Xin chào (Greet)</option>
          <option value="thank_you" ${shot.action === 'thank_you' ? 'selected' : ''}>Cảm ơn (Thank you)</option>
          <option value="bow" ${shot.action === 'bow' ? 'selected' : ''}>Cúi chào (Bow)</option>
          <option value="present" ${shot.action === 'present' ? 'selected' : ''}>Thuyết trình (Present)</option>
          <option value="angry" ${shot.action === 'angry' ? 'selected' : ''}>Giận dữ (Angry)</option>
          <option value="fight_punch" ${shot.action === 'fight_punch' ? 'selected' : ''}>Cú đấm (Punch)</option>
          <option value="walk" ${shot.action === 'walk' ? 'selected' : ''}>Đi bộ (Walk)</option>
          <option value="run" ${shot.action === 'run' ? 'selected' : ''}>Chạy nhanh (Run)</option>
        </select>
      </div>
      <div>
        <label class="shot-select-label">😊 Biểu cảm mặt:</label>
        <select class="shot-select sel-shot-expr">
          <option value="happy" ${shot.expression === 'happy' ? 'selected' : ''}>Vui tươi (Happy)</option>
          <option value="talking" ${shot.expression === 'talking' ? 'selected' : ''}>Đang nói (Talking)</option>
          <option value="laugh" ${shot.expression === 'laugh' ? 'selected' : ''}>Cười lớn (Laugh)</option>
          <option value="think" ${shot.expression === 'think' ? 'selected' : ''}>Suy nghĩ (Think)</option>
          <option value="dizzy" ${shot.expression === 'dizzy' ? 'selected' : ''}>Choáng váng (Dizzy)</option>
          <option value="embarrassed" ${shot.expression === 'embarrassed' ? 'selected' : ''}>Bối rối (Embarrassed)</option>
          <option value="neutral" ${shot.expression === 'neutral' ? 'selected' : ''}>Bình thường (Neutral)</option>
        </select>
      </div>
    </div>

    <div class="shot-row-2col">
      <div>
        <label class="shot-select-label">✨ Hiệu ứng Anime 3D:</label>
        <select class="shot-select sel-shot-emotion">
          <option value="none" ${!shot.emotionFx || shot.emotionFx === 'none' ? 'selected' : ''}>Không có</option>
          <option value="sweat" ${shot.emotionFx === 'sweat' ? 'selected' : ''}>💧 Giọt mồ hôi</option>
          <option value="anger" ${shot.emotionFx === 'anger' ? 'selected' : ''}>💢 Gân giận dữ</option>
          <option value="question" ${shot.emotionFx === 'question' ? 'selected' : ''}>❓ Dấu hỏi ngạc nhiên</option>
          <option value="exclamation" ${shot.emotionFx === 'exclamation' ? 'selected' : ''}>❗ Dấu chấm than</option>
          <option value="heart" ${shot.emotionFx === 'heart' ? 'selected' : ''}>❤️ Trái tim tình cảm</option>
        </select>
      </div>
      <div>
        <label class="shot-select-label">🎥 Góc máy điện ảnh:</label>
        <select class="shot-select sel-shot-camera">
          <option value="medium" ${shot.camera?.preset === 'medium' ? 'selected' : ''}>Trung cảnh (Medium)</option>
          <option value="close_up" ${shot.camera?.preset === 'close_up' ? 'selected' : ''}>Cận cảnh (Close-Up)</option>
          <option value="wide" ${shot.camera?.preset === 'wide' ? 'selected' : ''}>Toàn cảnh (Wide Shot)</option>
          <option value="over_shoulder" ${shot.camera?.preset === 'over_shoulder' ? 'selected' : ''}>Qua vai (Over Shoulder)</option>
          <option value="dutch_dramatic" ${shot.camera?.preset === 'dutch_dramatic' ? 'selected' : ''}>Nghiêng kịch tính (Dutch)</option>
          <option value="bird_eye" ${shot.camera?.preset === 'bird_eye' ? 'selected' : ''}>Góc mắt chim (Bird Eye)</option>
        </select>
      </div>
    </div>

    <div class="shot-dialogue-wrap">
      <label class="shot-select-label">💬 Lời thoại & Giọng đọc TTS:</label>
      <textarea class="shot-dialogue-input" placeholder="Nhập câu thoại nhân vật sẽ phát biểu...">${escapeHtml(shot.dialogue || '')}</textarea>
    </div>
  `;
}
